import {
  EditorCanvas,
  EditorToolbar,
  useEditorState,
} from "src/features/editor";
import { DataGenerator } from "src/features/generator";
import { AppMenu } from "src/components/app-menu";
import { css } from "src/styles/theme";
import { VFC } from "react";

export const AppPage: VFC = () => {
  const [state, dispatch] = useEditorState();

  return (
    <>
      <AppMenu />
      <div className={$app()}>
        <div className={$board()}>
          <div className={$toolbar()}>
            <EditorToolbar state={state} dispatch={dispatch} />
          </div>
          <div className={$canvas()}>
            <EditorCanvas state={state} dispatch={dispatch} />
          </div>
        </div>
        <div className={$output()}>
          <DataGenerator nodes={state.nodes} positions={state.positions} />
        </div>
      </div>
    </>
  );
};

const $app = css({
  display: "grid",
  gridTemplateRows: "minmax(75vh, auto)",

  "@large": {
    height: "100%",
    position: "fixed",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    gridTemplateColumns: "1fr 500px",
    overflow: "hidden",
  },
});

const $board = css({
  display: "grid",
  backgroundColor: "$neutralBase",
  overflow: "hidden",

  "& > *": {
    gridArea: "1 / 1 / -1 / -1",
  },
});

const $canvas = css({
  position: "relative",
});

const $toolbar = css({
  margin: "$8",
  alignSelf: "end",
  justifySelf: "end",
  zIndex: 5,
});

const $output = css({
  overflow: "hidden",
});
